import { GeoJSONType } from '@guiker/base-entity'
import {
  AddressValidationResponse,
  PostalAddress,
  transformAddressValidationResponseToBaseAddress,
} from '@guiker/google-map'

import { Address, BuildingLocation } from '../entity'

export const transformAddressToPostalAddress = (address: Address): PostalAddress => {
  return {
    regionCode: address.country,
    addressLines: [
      `${address.streetNumber} ${address.street}`,
      `${address.cityName ?? address.city}, ${address.country}, ${address.zipcode}`,
    ],
  }
}

export const transformAddressValidationResponseToAddress = ({
  operatingCity,
  res,
}: {
  res: AddressValidationResponse
  operatingCity: string
}): { address: Address; location: BuildingLocation } => {
  const { address, alternatives, geocode } = transformAddressValidationResponseToBaseAddress({ res })
  return {
    address: { ...address, city: operatingCity, zipcode: address.postalCode, alternatives } as Address,
    location: {
      type: GeoJSONType.POINT,
      coordinates: [geocode.location.longitude, geocode.location.latitude],
      externalId: geocode.placeId,
      region: operatingCity,
    },
  }
}
